import { vmInsight as vm } from "../../constants/actionTypes";

const getVmInsightList = (url) => ({
  type: vm.GET_VM_INSIGHT_LIST,
  data: url,
});

const setVmInsightList = (data) => ({
  type: vm.SET_VM_INSIGHT_LIST,
  data: data,
});

const setVmInsightListError = (data) => ({
  type: vm.SET_VM_INSIGHT_LIST_ERROR,
  data: data,
});

const getVmInsightDetailsList = (url) => ({
  type: vm.GET_VM_INSIGHT_DETAILS_LIST,
  data: url,
});

const setVmInsightDetailsList = (data) => ({
  type: vm.SET_VM_INSIGHT_DETAILS_LIST,
  data: data,
});

const setVmInsightDetailsListError = (data) => ({
  type: vm.SET_VM_INSIGHT_DETAILS_LIST_ERROR,
  data: data,
});

const setVmInsightListLoader = (payload) => ({
  type: vm.SET_VM_INSIGHT_LIST_LOADER,
  data: payload,
});

export {
  getVmInsightList,
  setVmInsightList,
  setVmInsightListError,
  setVmInsightListLoader,
  getVmInsightDetailsList,
  setVmInsightDetailsList,
  setVmInsightDetailsListError,
};
